import { Typography } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledTypography = styled(Typography) `
  white-space: nowrap;
`;
